import api from "config/axiosConfig";
import { apiRoutes } from "util/apiRoutes";
import type {
  SearchResponse,
  SearchFilters,
  SearchScope,
  SearchSuggestionsResponse,
  TrendingSearchResponse,
} from "types/search";

interface SearchInput extends SearchFilters {
  query: string;
  scope?: SearchScope;
  limit?: number;
  offset?: number;
}

interface SuggestionInput extends SearchFilters {
  query: string;
  limit?: number;
}

interface TrendingInput {
  limit?: number;
}

export const searchApi = {
  search: async ({
    query,
    scope = "all",
    resultTypes,
    postKinds,
    collectionTypes,
    issueRelated,
    limit = 20,
    offset = 0,
  }: SearchInput): Promise<SearchResponse> => {
    const response = await api.get<SearchResponse>(apiRoutes.search.root, {
      params: {
        q: query,
        type: scope,
        resultTypes: resultTypes?.join(","),
        postKinds: postKinds?.join(","),
        collectionTypes: collectionTypes?.join(","),
        issueRelated: issueRelated ? "1" : undefined,
        limit,
        offset,
      },
    });

    return response.data;
  },

  getSuggestions: async ({
    query,
    resultTypes,
    postKinds,
    collectionTypes,
    issueRelated,
    limit = 5,
  }: SuggestionInput): Promise<SearchSuggestionsResponse> => {
    const response = await api.get<SearchSuggestionsResponse>(apiRoutes.search.suggestions, {
      params: {
        q: query,
        resultTypes: resultTypes?.join(","),
        postKinds: postKinds?.join(","),
        collectionTypes: collectionTypes?.join(","),
        issueRelated: issueRelated ? "1" : undefined,
        limit,
      },
    });

    return response.data;
  },

  getTrending: async ({
    limit = 6,
  }: TrendingInput = {}): Promise<TrendingSearchResponse> => {
    const response = await api.get<TrendingSearchResponse>(apiRoutes.search.trending, {
      params: {
        limit,
      },
    });

    return response.data;
  },
};
